export default {
  modifyAction: "Modify",
  duplicateAction: "Duplicate",
  duplicateScenarioAction: "Duplicate Scenario",
  approveAction: "Approve",
  generateAction: "Regenerate Output",
  disapproveAction: "Cancel Approve",
  compareAction: "Compare",
  deleteAction: "Delete",
  deleteScenarioAction: "Delete Scenario",
  exportCsvAction: "CSV",
  exportPNGAction: "PNG",
};
